#import "../../../../core/schema/fragments/InquiryFull.graphql"

query (
  $id: ID!
) {
  getWeddingInquiry(
    id: $id
  ) {
    ...InquiryFull
  }
}
